module.exports = __webpack_public_path__ + "img/menu-logo.5c1a6fe5.svg";